import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'DownloadDropdown',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        downloadLinks: {
            type: Array,
            required: true
        },
        downloadArtifacts: {
            type: Array,
            required: true
        },
        cssClass: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        hasDownloadLinks () {
            return this.downloadLinks.length;
        },
        hasDownloadArtifacts () {
            return this.downloadArtifacts.length;
        },
        showDownloadArtifactsBorder () {
            return this.hasDownloadLinks > 0;
        },
        sourceCodeGroup () {
            const items = this.downloadLinks.map((link)=>({
                    text: link.text,
                    href: link.path,
                    extraAttrs: {
                        rel: 'nofollow',
                        download: ''
                    }
                }));
            return {
                name: this.$options.i18n.downloadSourceCode,
                items
            };
        },
        artifactsGroup () {
            const items = this.downloadArtifacts.map((link)=>({
                    text: link.text,
                    href: link.path,
                    extraAttrs: {
                        rel: 'nofollow',
                        download: ''
                    }
                }));
            return {
                name: this.$options.i18n.downloadArtifacts,
                items
            };
        }
    },
    methods: {
        closeDropdown () {
            this.$refs.dropdown.close();
        }
    },
    i18n: {
        defaultLabel: __('Download'),
        downloadSourceCode: __('Download source code'),
        downloadArtifacts: __('Download artifacts')
    }
};
